import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-center gap-5 px-4 py-24 text-center md:px-8 md:py-32">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-background-100 text-primary-500">
        <i className="ri-movie-2-line text-4xl" />
      </span>
      <p className="text-5xl font-black tracking-tight text-foreground-950 md:text-6xl">404</p>
      <h1 className="text-xl font-bold text-foreground-950 md:text-2xl">没有找到这个页面</h1>
      <p className="max-w-md text-sm text-foreground-500 md:text-base">
        你访问的页面可能已被移动或不存在。可以返回首页，或通过导航继续探索男同视频的精彩内容。
      </p>
      <p className="rounded-md bg-background-100 px-3 py-1 font-mono text-xs text-foreground-400">
        {location.pathname}
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-5-line" />
          返回首页
        </Link>
        <Link
          to="/category/drama"
          className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-film-line" />
          浏览剧情内容
        </Link>
      </div>
    </div>
  );
}